export enum ShipmentActivityType {
    MILESTONE_CHANGE = 'milestone-change',
    STATUS_UPDATE = 'status-update',
    DOCUMENT = 'document',
    COMMENT = 'comment',
    SCHEDULE_CHANGE = 'schedule-change',
}
